var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 6419",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20984",
    d: "M25.992 13.509a4.624 4.624 0 0 1-2.773-.916 4.54 4.54 0 0 1-1.741-2.743 4.519 4.519 0 0 1-.091-.851h-2.974V21.43a2.663 2.663 0 0 1-1.849 2.524 2.734 2.734 0 0 1-1 .131 2.7 2.7 0 0 1-1.231-.373 2.651 2.651 0 0 1 1.381-4.941 2.733 2.733 0 0 1 .849.135V15.92a5.919 5.919 0 0 0-.857-.063 5.732 5.732 0 0 0-4.284 1.894 5.477 5.477 0 0 0 .252 7.616 5.726 5.726 0 0 0 4.032 1.632 5.919 5.919 0 0 0 .857-.062 5.708 5.708 0 0 0 3.175-1.569 5.471 5.471 0 0 0 1.67-3.916l-.015-6.569a7.533 7.533 0 0 0 1.67.963 7.593 7.593 0 0 0 2.94.586v-2.923h-.009Z",
    fill: "#414e5e",
    stroke: "#414e5e",
    strokeWidth: 0.3
  })));
};
export default SvgTiktok;